import React, { useState, useEffect } from 'react';
import {
  AdminContentContainer,
  AdminContentTitle,
  AdminContentSearchContainer,
  AdminContentSearchInputUser,
  UserList,
  UserItem,
  UserDetailsContainer,
  UserDetail,
  NoResults,
} from '../styles';
import { getUsers } from '../api';
import { Spinner } from ".";

const UserDetailsWithList = () => {
  const [search, setSearch] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
      
        const response = await getUsers();

        const data = await response.json();

        setUsers(data);

      } catch (error) {
        console.error("Erro ao buscar as datas:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const handleSelectUser = (user) => {
    if (selectedUser && selectedUser.user_id === user.user_id) {
      setSelectedUser(null);

    } else {
      setSelectedUser(user);
    }

    setSearch('');
  };

  const filteredUsers = users.filter((user) =>
    user.fullName.toLowerCase().includes(search.toLowerCase())
  );

  const formatCNPJ = (cnpj) => {
  if (!cnpj) return cnpj; // Retorna o CNPJ sem formatação se for nulo ou indefinido
  return cnpj
    .replace(/\D/g, '') // Remove tudo que não é número
    .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5'); // Formata o CNPJ
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <AdminContentContainer>
      <AdminContentTitle>Visualizar Dados Cadastrais</AdminContentTitle>

      <AdminContentSearchContainer>
        <AdminContentSearchInputUser
          type="text"
          placeholder="Buscar usuário pelo nome..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </AdminContentSearchContainer>

      <UserList>
        {(search ? filteredUsers : users).map((user) => (
          <UserItem
            key={user.user_id}
            onClick={() => handleSelectUser(user)}
          >
            {user.fullName} ({user.email})
          </UserItem>
        ))}
        {!filteredUsers.length && search && (
          <NoResults>Nenhum usuário encontrado</NoResults>
        )}
      </UserList>

      {selectedUser && (
        <UserDetailsContainer>
          <UserDetail>
            <strong>Nome Completo:</strong> {selectedUser.fullName}
          </UserDetail>
          <UserDetail>
            <strong>E-mail:</strong> {selectedUser.email}
          </UserDetail>
          <UserDetail>
            <strong>Telefone:</strong> {selectedUser.phone}
          </UserDetail>
          <UserDetail>
            <strong>Endereço:</strong> {selectedUser.address}
          </UserDetail>
          <UserDetail>
            <strong>Complemento:</strong> {selectedUser.complement}
          </UserDetail>
          <UserDetail>
            <strong>CPF:</strong> {selectedUser.cpf}
          </UserDetail>
          <UserDetail>
            <strong>Username:</strong> {selectedUser.username}
          </UserDetail>
          <UserDetail>
            <strong>Role:</strong> {selectedUser.role}
          </UserDetail>

          {selectedUser.role === 'Professor' && (
            <div>
              <UserDetail>
                <strong>CREF:</strong> {selectedUser.cref}
              </UserDetail>
              <UserDetail>
                <strong>CNPJ:</strong> {formatCNPJ(selectedUser.cnpj)}
              </UserDetail>
            </div>
          )}
        </UserDetailsContainer>
      )}
    </AdminContentContainer>
  );
}

export default UserDetailsWithList;
